import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import EditButton from '@/components/EditButton.vue';
    import { useI18n } from 'vue-i18n';
    import type { Table, Row } from '@tanstack/vue-table';
    import type { VatSubmission } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditVat',
  props: {
    table: {},
    row: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const editFields = () => {
        props.table.options.meta?.updateData?.(props.row, 'status', 'draft');
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EditButton, { onClick: editFields }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('tables.edit')), 1)
    ]),
    _: 1
  }))
}
}

})